export default __webpack_public_path__ + "static/media/OrangeDots.ebef0b86.svg";